import { useQuery } from 'react-query';
import * as analyzerService from '../services/analyzerService';


export const useAnalyzeProductInfo = (
  suggestionId: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestionInfo', suggestionId],
    queryFn: () => analyzerService.getProductSuggestionInfo(suggestionId),
    ...options
  });
}

export const useAnalyzeProductDescription = (
  suggestionId: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestionDescription', suggestionId],
    queryFn: () => analyzerService.getProductSuggestionDescription(suggestionId),
    ...options
  });
}

export const useAnalyzeProductContents = (
  suggestionId: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestionContents', suggestionId],
    queryFn: () => analyzerService.getProductSuggestionContents(suggestionId),
    ...options
  });
}

export const useAnalyzeProductUsages = (
  suggestionId: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestionUsages', suggestionId],
    queryFn: () => analyzerService.getProductSuggestionUsages(suggestionId),
    ...options
  });
}

export const useAnalyzeProductIngredients = (
  suggestionId: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestionIngredients', suggestionId],
    queryFn: () => analyzerService.getProductSuggestionIngredients(suggestionId),
    ...options
  });
}

export const useAnalyzeProductOcrText = (
  suggestionId: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestionOcrText', suggestionId],
    queryFn: () => analyzerService.getProductSuggestionOcrText(suggestionId),
    ...options
  });
}

export const useAnalyzeProductCategories = (
  suggestionId: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productSuggestionCategories', suggestionId],
    queryFn: () => analyzerService.getProductSuggestionCategories(suggestionId),
    ...options
  });
}
